'use client'

import { useMemo, useState } from 'react'
import { calcPaintQuantity } from '@/lib/calculators/formulas'
import { ToolField, ToolResultCard, ToolResultRow, toolCurrency, toolFmt, toolNum } from './tool-inputs'

// Reuses the in-app paint math (calcPaintQuantity) so results match the product.
export function PaintCalculatorTool() {
  const [area, setArea] = useState('50')
  const [coats, setCoats] = useState('2')
  const [coverage, setCoverage] = useState('10')
  const [waste, setWaste] = useState('10')
  const [price, setPrice] = useState('120')

  const r = useMemo(() => {
    const { litresRaw } = calcPaintQuantity(toolNum(area), toolNum(coats), toolNum(coverage), 1 + toolNum(waste) / 100)
    return {
      litres: litresRaw,
      cans5: Math.ceil(litresRaw / 5),
      cans20: Math.ceil(litresRaw / 20),
      cost: litresRaw * toolNum(price),
    }
  }, [area, coats, coverage, waste, price])

  return (
    <div className="grid gap-6 md:grid-cols-[1fr_380px] md:items-start">
      <div className="space-y-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Surface</h2>
          <div className="mt-3 grid grid-cols-3 gap-3">
            <ToolField label="Area" value={area} onChange={setArea} unit="m²" />
            <ToolField label="Coats" value={coats} onChange={setCoats} unit="×" />
            <ToolField label="Coverage" value={coverage} onChange={setCoverage} unit="m²/L" hint="Smooth 10, rough 5" />
          </div>
        </div>
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Waste &amp; price</h2>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <ToolField label="Waste allowance" value={waste} onChange={setWaste} unit="%" hint="10% typical" />
            <ToolField label="Paint price" value={price} onChange={setPrice} unit="R/L" />
          </div>
        </div>
      </div>

      <ToolResultCard title="Your paint estimate">
        <ToolResultRow label="Paint needed (incl. waste)" value={`${toolFmt(r.litres, 1)} L`} />
        <ToolResultRow label="5 L cans to buy" value={`${r.cans5} cans`} />
        <ToolResultRow label="20 L cans to buy" value={`${r.cans20} cans`} />
        <ToolResultRow label="Estimated paint cost" value={toolCurrency(r.cost)} strong />
      </ToolResultCard>
    </div>
  )
}
